import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import { handleError } from '../user';
import history from '../../config/history';
import _ from 'underscore';
import formatDate from '../../services/formatDate';
import mixpanelConstants from '../../constants/mixpanel';
import moment from 'moment';
import { isFeatureActive } from '../features';
import testFeatures from '../../constants/testFeatures';

export const resetShift = createAction('REST_SHIFT');
export const setShiftLocationID = createAction('SET_SHIFT_LOCATION_ID');
export const setLocDepartmentList = createAction('SET_SHIFT_DEPARTMENT_LIST');
export const setShiftDepartmentID = createAction('SET_SHIFT_DEPARTMENT_ID');
export const setShiftStartDate = createAction('SET_SHIFT_START_DATE');
export const setShiftEndDate = createAction('SET_SHIFT_END_DATE');
export const setShiftTimeList = createAction('SET_SHIFT_TIME_LIST');
export const setShiftNote = createAction('SET_SHIFT_NOTE');
export const setCustomShiftStartAt = createAction('SET_CUSTOM_SHIFT_START_AT');
export const setCustomShiftPeriod = createAction('SET_CUSTOM_SHIFT_PERIOD');
export const setCustomShiftDuration = createAction('SET_CUSTOM_SHIFT_DURATION');
export const setShiftOpenPositions = createAction('SET_SHIFT_OPEN_POSITIONS');
export const setPartTimeNotifyAfter = createAction('SET_SHIFT_PARTTIME_NOTIFY_AFTER');
export const setFullTimeNotifyAfter = createAction('SET_SHIFT_FULLTIME_NOTIFY_AFTER');
export const setExternalNotifyAfter = createAction('SET_SHIFT_EXTERNAL_NOTIFY_AFTER');
export const setPartTimeNotifyAfterHr = createAction('SET_SHIFT_PARTTIME_NOTIFY_AFTER_HR');
export const setFullTimeNotifyAfterHr = createAction('SET_SHIFT_FULLTIME_NOTIFY_AFTER_HR');
export const setExternalNotifyAfterHr = createAction('SET_SHIFT_EXTERNAL_NOTIFY_AFTER_HR');
export const setShiftTime = createAction('SET_SHIFT_TIME');
export const setShiftRoles = createAction('SET_SHIFT_ROLES');
export const setShiftRecurring = createAction('SET_SHIFT_RECURRING');
export const setShiftPost = createAction('SET_SHIFT_POST_STATUS');
export const setShiftOrganizationID = createAction('SET_SHIFT_ORGANIZATION_ID');
export const setEditShiftDetails = createAction('SET_EDIT_SHIFT_DETAILS');
export const setHasApplicants = createAction('SET_HAS_APPLICANTS');

export const setCustomShiftStartTime = createAction('SET_CUSTOM_SHIFT_START_TIME');
export const setCustomShiftEndTime = createAction('SET_CUSTOM_SHIFT_END_TIME');

export const setMultipleDates = createAction('EDIT_SHIFT/SET_MULTIPLE_DATES');

export const setPRNPoolEnabled = createAction('EDIT_SHIFT/SET_PRN_POOL_ENABLED');
export const setPRNPoolDays = createAction('EDIT_SHIFT/SET_PRN_POOL_DAYS');

export const setHasCovidPatients = createAction('EDIT_SHIFT/SET_HAS_COVID_PATIENTS');
export const setCovidContactFlag = createAction('EDIT_SHIFT/SET_COVID_CONTACT_FLAG');

const initialState = {
	covidContactFlag: null,
	customShiftDuration: '',
	customShiftEndTime: null,
	customShiftPeriod: 'AM',
	customShiftStartAt: '',
	customShiftStartTime: null,
	dates: [],
	departmentID: 0,
	details: {},
	externalNotifyAfterHr: '',
	fullTimeNotifyAfterHr: '',
	hasApplicants: false,
	hasCovidPatients: null,
	is_externalNotifyAfter: true,
	is_fullTimeNotifyAfter: true,
	is_partTimeNotifyAfter: true,
	is_recurring: 0,
	locationID: 0,
	locDepartmentList: [],
	nurseRole: [],
	openPositions: '1',
	organizationID: '',
	partTimeNotifyAfterHr: '',
	prnPoolDays: '',
	prnPoolEnabled: null,
	readyToPost: false,
	shiftEndDate: '',
	shiftNote: '',
	shiftRoles: [],
	shiftStartDate: '',
	shiftTimeID: '',
	shiftTimeList: []
};

export default handleActions(
	{
		'EDIT_SHIFT/SET_COVID_CONTACT_FLAG': (state, action) => ({ ...state, covidContactFlag: action.payload }),
		'EDIT_SHIFT/SET_HAS_COVID_PATIENTS': (state, action) => ({ ...state, hasCovidPatients: action.payload }),
		'EDIT_SHIFT/SET_MULTIPLE_DATES': (state, action) => ({ ...state, dates: action.payload }),
		'EDIT_SHIFT/SET_PRN_POOL_DAYS': (state, action) => ({ ...state, prnPoolDays: action.payload }),
		'EDIT_SHIFT/SET_PRN_POOL_ENABLED': (state, action) => ({ ...state, prnPoolEnabled: action.payload }),
		REST_SHIFT: () => initialState,
		SET_CUSTOM_SHIFT_DURATION: (state, action) => ({ ...state, customShiftDuration: action.payload }),
		SET_CUSTOM_SHIFT_END_TIME: (state, action) => ({ ...state, customShiftEndTime: action.payload }),
		SET_CUSTOM_SHIFT_PERIOD: (state, action) => ({ ...state, customShiftPeriod: action.payload }),
		SET_CUSTOM_SHIFT_START_AT: (state, action) => ({ ...state, customShiftStartAt: action.payload }),
		SET_CUSTOM_SHIFT_START_TIME: (state, action) => ({ ...state, customShiftStartTime: action.payload }),
		SET_EDIT_SHIFT_DETAILS: (state, action) => ({ ...state, details: action.payload }),
		SET_HAS_APPLICANTS: (state, action) => ({ ...state, hasApplicants: action.payload }),
		SET_SHIFT_DEPARTMENT_ID: (state, action) => ({ ...state, departmentID: action.payload }),
		SET_SHIFT_DEPARTMENT_LIST: (state, action) => ({ ...state, locDepartmentList: action.payload }),
		SET_SHIFT_END_DATE: (state, action) => ({ ...state, shiftEndDate: action.payload }),
		SET_SHIFT_EXTERNAL_NOTIFY_AFTER: (state, action) => ({ ...state, is_externalNotifyAfter: action.payload }),
		SET_SHIFT_EXTERNAL_NOTIFY_AFTER_HR: (state, action) => ({ ...state, externalNotifyAfterHr: action.payload }),
		SET_SHIFT_FULLTIME_NOTIFY_AFTER: (state, action) => ({ ...state, is_fullTimeNotifyAfter: action.payload }),
		SET_SHIFT_FULLTIME_NOTIFY_AFTER_HR: (state, action) => ({ ...state, fullTimeNotifyAfterHr: action.payload }),
		SET_SHIFT_LOCATION_ID: (state, action) => ({ ...state, locationID: action.payload }),
		SET_SHIFT_NOTE: (state, action) => ({ ...state, shiftNote: action.payload }),
		SET_SHIFT_OPEN_POSITIONS: (state, action) => ({ ...state, openPositions: action.payload }),
		SET_SHIFT_ORGANIZATION_ID: (state, action) => ({ ...state, organizationID: action.payload }),
		SET_SHIFT_PARTTIME_NOTIFY_AFTER: (state, action) => ({ ...state, is_partTimeNotifyAfter: action.payload }),
		SET_SHIFT_PARTTIME_NOTIFY_AFTER_HR: (state, action) => ({ ...state, partTimeNotifyAfterHr: action.payload }),
		SET_SHIFT_POST_STATUS: (state, action) => ({ ...state, readyToPost: action.payload }),
		SET_SHIFT_RECURRING: (state, action) => ({ ...state, is_recurring: action.payload }),
		SET_SHIFT_ROLES: (state, action) => ({ ...state, shiftRoles: action.payload }),
		SET_SHIFT_START_DATE: (state, action) => ({ ...state, shiftStartDate: action.payload }),
		SET_SHIFT_TIME: (state, action) => ({ ...state, shiftTimeID: action.payload }),
		SET_SHIFT_TIME_LIST: (state, action) => ({ ...state, shiftTimeList: action.payload })
	},
	initialState
);

export const getOrganizationShiftTimes = (id) => {
	return function (dispatch) {
		Agent.getOrgShiftTimes(id).then((response) => {
			if (response.ok) {
				dispatch(setShiftTimeList(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const updateShft = (shift_id) => {
	return function (dispatch, getState) {
		let shift_start = '';
		let shift_end = '';
		let shift_start_date = getState().supervisorShift.shiftStartDate;
		let shift_end_date = getState().supervisorShift.shiftEndDate;
		let edit_shift_date = getState().editShift.dates[0];
		let timeID = getState().supervisorShift.shiftTimeID;
		let timeList = getState().supervisorShift.shiftTimeList;
		let customShiftStartTime = getState().supervisorShift.customShiftStartTime;
		let customShiftEndTime = getState().supervisorShift.customShiftEndTime;

		if (timeID) {
			shift_start = _.where(timeList, { id: timeID })[0].start_time;
			shift_end = _.where(timeList, { id: timeID })[0].end_time;
		} else {
			shift_start = moment(customShiftStartTime).format('HH:mm:00');
			shift_end = moment(customShiftEndTime).format('HH:mm:00');
		}

		if (shift_start_date != '') {
			shift_start_date = formatDate.clientDateToYyMmDd(shift_start_date);
		}

		if (shift_end_date != '') {
			shift_end_date = formatDate.clientDateToYyMmDd(shift_end_date);
		}

		if (isFeatureActive(testFeatures.SUPERVISOR_NEW_CALENDAR, getState().features.globalFeatures)) {
			shift_start_date = moment(edit_shift_date) && moment(edit_shift_date).format('YYYY-MM-DD');
		}

		let shiftObj = {
			aft_delay: parseInt(getState().editShift.fullTimeNotifyAfterHr),
			allow_external_nurses: getState().editShift.is_externalNotifyAfter == true ? 'Y' : 'N',
			allow_full_time_nurses: getState().editShift.is_fullTimeNotifyAfter == true ? 'Y' : 'N',
			allow_part_time_nurses: getState().editShift.is_partTimeNotifyAfter == true ? 'Y' : 'N',
			aoa_delay: parseInt(getState().editShift.externalNotifyAfterHr),
			apt_delay: parseInt(getState().editShift.partTimeNotifyAfterHr),
			covid_contact_flag: getState().editShift.covidContactFlag,
			department_id: parseInt(getState().editShift.departmentID),
			has_covid_patients: getState().editShift.hasCovidPatients,
			location_id: parseInt(getState().editShift.locationID),
			nurse_role: getState().editShift.shiftRoles,
			//07:00:00
			open_positions: parseInt(getState().editShift.openPositions),
			organization_id: parseInt(getState().editShift.organizationID),
			prn_pool_duration_in_days: parseInt(getState().editShift.prnPoolDays)
				? parseInt(getState().editShift.prnPoolDays)
				: null,
			prn_pool_enabled: getState().editShift.prnPoolEnabled,
			shift_date: shift_start_date,
			// 07:00:00
			shift_end: shift_end,
			shift_end_date: shift_end_date,
			shift_id: shift_id,
			shift_notes: getState().editShift.shiftNote,
			shift_start: shift_start
		};

		Agent.updateShift(shiftObj).then((response) => {
			if (response.ok) {
				trackShiftUpdate(shiftObj, getState());
				dispatch(resetShift());
				history.push('/');
			} else {
				if (response.status === 409) {
					if (response.data.includes('COVID-19 Contact status')) {
						dispatch(setCovidContactFlag(!shiftObj.covid_contact_flag));
						dispatch(setHasApplicants(true));
					}
				}
				dispatch(handleError(response));
			}
		});
	};
};

function trackShiftUpdate(shiftObj, appState) {
	const supervisorDashboard = appState.supervisordashboard;

	const organizationTitle = supervisorDashboard.organizations.title;
	const { roles, locations } = supervisorDashboard;

	const location = locations.filter((l) => l.location_id == shiftObj.location_id)[0];
	const roleStr = roles
		.filter((r) => shiftObj.nurse_role.includes(r.id))
		.map((r) => r.name)
		.join(',');

	const shift = {
		allowExternalNurses: shiftObj.allow_external_nurses,
		allowFullTimeNurses: shiftObj.allow_full_time_nurses,
		allowPartTimeNurses: shiftObj.allow_part_time_nurses,
		externalNotifyAfterHr: shiftObj.externalNotifyAfterHr,
		fullTimeNotifyAfterHr: shiftObj.fullTimeNotifyAfterHr,
		location: location.location_name,
		nurseRole: roleStr,
		organization: organizationTitle,
		partTimeNotifyAfterHr: shiftObj.partTimeNotifyAfterHr,
		prnPoolDays: shiftObj.prnPoolDays,
		prnPoolEnabled: shiftObj.prnPoolEnabled,
		shiftEnd: shiftObj.shift_end,
		shiftEndDate: shiftObj.shift_end_date,
		shiftNotes: shiftObj.shift_notes,
		shiftStart: shiftObj.shift_start,
		shiftStartDate: shiftObj.shift_date
	};

	mixpanel.track(mixpanelConstants.UPDATE_SHIFT, shift);
}
